var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHearthSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.583,
    height: 18.854,
    viewBox: "0 0 21.583 18.854",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "heart",
    d: "M18.792,28.854l-.381-.317C10.222,21.871,8,19.522,8,15.713A5.689,5.689,0,0,1,13.713,10a6.485,6.485,0,0,1,5.078,2.6A6.485,6.485,0,0,1,23.87,10a5.689,5.689,0,0,1,5.713,5.713c0,3.809-2.222,6.158-10.411,12.823Z",
    transform: "translate(-8 -10)",
    fill: "#2D3040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHearthSolid);
export default __webpack_public_path__ + "static/media/hearth-solid.34476d9d4947ceb29e120565e5bfe50e.svg";
export { ForwardRef as ReactComponent };